import { fetch, schemas } from '../utils/fetch'
import {
  ENDPOINT_KEYWORD_PARENTS,
  ENDPOINT_KEYWORD_HIERARCHY,
  ENDPOINT_KEYWORD_GRAPH
} from '../constants'

const FETCH_KEYWORD_PARENTS_REQUEST = 'blayzr/keywords/FETCH_PARENTS_REQUEST'
const FETCH_KEYWORD_PARENTS_SUCCESS = 'blayzr/keywords/FETCH_PARENTS_SUCCESS'
const FETCH_KEYWORD_PARENTS_FAILURE = 'blayzr/keywords/FETCH_PARENTS_FAIL'

const FETCH_KEYWORD_HIERARCHY_REQUEST = 'blayzr/keywords/FETCH_HIERARCHY_REQUEST'
const FETCH_KEYWORD_HIERARCHY_SUCCESS = 'blayzr/keywords/FETCH_HIERARCHY_SUCCESS'
const FETCH_KEYWORD_HIERARCHY_FAILURE = 'blayzr/keywords/FETCH_HIERARCHY_FAIL'

const FETCH_KEYWORD_GRAPH_REQUEST = 'blayzr/keywords/FETCH_GRAPH_REQUEST'
const FETCH_KEYWORD_GRAPH_SUCCESS = 'blayzr/keywords/FETCH_GRAPH_SUCCESS'
const FETCH_KEYWORD_GRAPH_FAILURE = 'blayzr/keywords/FETCH_GRAPH_FAIL'

const UPDATE_GRAPH_NODES = 'blayzr/keywords/UPDATE_GRAPH_NODES'
const TOGGLE_EXPANDED = 'blayzr/keywords/TOGGLE_EXPANDED'

const initialState = {
  parents: {
    data: null,
    fetching: false,
    error: null
  },
  hierarchy: {
    data: null,
    fetching: false,
    error: null,
    expanded: []
  },
  graph: {
    data: null,
    fetching: false,
    error: null
  }
}

export default function reducer (state = initialState, action = {}) {
  const { type } = action
  switch (type) {
    case FETCH_KEYWORD_PARENTS_REQUEST:
    case FETCH_KEYWORD_PARENTS_SUCCESS:
    case FETCH_KEYWORD_PARENTS_FAILURE:
      return {
        ...state,
        parents: subreducer(state.parents, action)
      }
    case FETCH_KEYWORD_HIERARCHY_REQUEST:
    case FETCH_KEYWORD_HIERARCHY_SUCCESS:
    case FETCH_KEYWORD_HIERARCHY_FAILURE:
    case TOGGLE_EXPANDED:
      return {
        ...state,
        hierarchy: subreducer(state.hierarchy, action)
      }
    case FETCH_KEYWORD_GRAPH_REQUEST:
    case FETCH_KEYWORD_GRAPH_SUCCESS:
    case FETCH_KEYWORD_GRAPH_FAILURE:
    case UPDATE_GRAPH_NODES:
      return {
        ...state,
        graph: subreducer(state.graph, action)
      }
    default:
      return state
  }
}

function subreducer (state, action = {}) {
  const { type, payload, meta } = action
  switch (type) {
    case FETCH_KEYWORD_PARENTS_REQUEST:
    case FETCH_KEYWORD_HIERARCHY_REQUEST:
    case FETCH_KEYWORD_GRAPH_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case FETCH_KEYWORD_PARENTS_SUCCESS:
    case FETCH_KEYWORD_HIERARCHY_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload
      }
    case FETCH_KEYWORD_GRAPH_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload.result
      }
    case FETCH_KEYWORD_PARENTS_FAILURE:
    case FETCH_KEYWORD_HIERARCHY_FAILURE:
    case FETCH_KEYWORD_GRAPH_FAILURE:
      return {
        ...state,
        fetching: false,
        error: payload
      }
    case TOGGLE_EXPANDED:
      const expanded =
        state.expanded.indexOf(payload) === -1
        ? state.expanded.concat(payload)
        : state.expanded.filter(path => path !== payload)
      return {
        ...state,
        expanded
      }
    default:
      return state
  }
}

function updateGraphState (graph, data, successNodes) {
  const updateNode = node => {
    let update = {}
    if (successNodes.indexOf(node._id.toString()) !== -1 && data[node._id]) {
      update = data[node._id]
    }
    return {
      ...node,
      ...update,
      children: node.children.map(updateNode)
    }
  }
  return graph.map(updateNode)
}

function fetchKeywordParentsRequest () {
  return {
    type: FETCH_KEYWORD_PARENTS_REQUEST
  }
}

function fetchKeywordParentsSuccess (data) {
  return {
    type: FETCH_KEYWORD_PARENTS_SUCCESS,
    payload: data
  }
}

function fetchKeywordParentsFailure (error) {
  return {
    type: FETCH_KEYWORD_PARENTS_FAILURE,
    payload: error
  }
}

function fetchKeywordHierarchyRequest () {
  return {
    type: FETCH_KEYWORD_HIERARCHY_REQUEST
  }
}

function fetchKeywordHierarchySuccess (data) {
  return {
    type: FETCH_KEYWORD_HIERARCHY_SUCCESS,
    payload: data['PHOTO PROJECT']
  }
}

function fetchKeywordHierarchyFailure (error) {
  return {
    type: FETCH_KEYWORD_HIERARCHY_FAILURE,
    payload: error
  }
}

function fetchKeywordGraphRequest () {
  return {
    type: FETCH_KEYWORD_GRAPH_REQUEST
  }
}

function fetchKeywordGraphSuccess (data) {
  return {
    type: FETCH_KEYWORD_GRAPH_SUCCESS,
    payload: data
  }
}

function fetchKeywordGraphFailure (error) {
  return {
    type: FETCH_KEYWORD_GRAPH_FAILURE,
    payload: error
  }
}

export function toggleExpanded (keyword) {
  return {
    type: TOGGLE_EXPANDED,
    payload: keyword
  }
}

export function fetchKeywordParents () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      cache: 60 * 24 * 7 // Cache result for one week
    }
    dispatch(fetchKeywordParentsRequest())
    fetch(ENDPOINT_KEYWORD_PARENTS, options, dispatch).then(data => {
      dispatch(fetchKeywordParentsSuccess(data))
    }, e => {
      dispatch(fetchKeywordParentsFailure(e))
    })
  }
}

export function fetchKeywordHierarchy () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      cache: 60 * 24 * 7 // Cache result for one week
    }
    dispatch(fetchKeywordHierarchyRequest())
    fetch(ENDPOINT_KEYWORD_HIERARCHY, options, dispatch).then(data => {
      dispatch(fetchKeywordHierarchySuccess(data))
    }, e => {
      dispatch(fetchKeywordHierarchyFailure(e))
    })
  }
}

export function fetchKeywordGraph () {
  return (dispatch, getState) => {
    const options = {
      token: getState().auth.token,
      query: {
        mode: 'array'
      },
      schema: {
        keywords: schemas.graph,
        tags: schemas.graph
      }
    }
    dispatch(fetchKeywordGraphRequest())
    return fetch(ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(data => {
      for (let id of Object.keys(data.entities.graph)) {
        const node = data.entities.graph[id]
        data.entities.graph[node.id] = node
      }
      dispatch(fetchKeywordGraphSuccess(data))
    }, e => {
      dispatch(fetchKeywordGraphFailure(e))
    })
  }
}

export function updateGraphNodes (body) {
  return (dispatch, getState) => {
    const options = {
      method: 'put',
      token: getState().auth.token,
      body
    }
    return fetch(ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(response => {
      response.nodes_ignored.forEach(id => delete body[id])
      dispatch({
        type: UPDATE_GRAPH_NODES,
        payload: {
          entities: {
            graph: body
          }
        }
      })
    })
  }
}

export function mergeNodes (id1, id2) {
  return (dispatch, getState) => {
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: {
        merge_node: [id1, id2]
      },
      schema: {
        parent_update: {
          keywords: schemas.graph,
          tags: schemas.graph
        }
      }
    }
    return fetch(ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(data => {
      if (data.entities.graph) {
        for (let id of Object.keys(data.entities.graph)) {
          const node = data.entities.graph[id]
          data.entities.graph[node.id] = node
        }
      }
      dispatch({
        type: UPDATE_GRAPH_NODES,
        payload: {
          entities: {
            graph: data.entities.graph
          }
        }
      })
      return data
    })
  }
}

export function deleteNode (id) {
  return (dispatch, getState) => {
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: {
        delete_node: id
      }
    }
    return fetch(ENDPOINT_KEYWORD_GRAPH, options, dispatch).then(() => {
      dispatch({
        type: UPDATE_GRAPH_NODES,
        payload: {
          entities: {
            graph: {
              [id]: null
            }
          }
        }
      })
    })
  }
}

export function touchNode (node, key) {
  return (dispatch, getState) => {
    const options = {
      method: 'post',
      token: getState().auth.token,
      body: {
        touch_node: node._id,
        key
      }
    }
    const timestamp = Math.round(new Date() / 1000)
    dispatch({
      type: UPDATE_GRAPH_NODES,
      payload: {
        entities: {
          graph: {
            [node.id]: {
              [key]: timestamp
            },
            [node._id]: {
              [key]: timestamp
            }
          }
        }
      }
    })
    return fetch(ENDPOINT_KEYWORD_GRAPH, options, dispatch)
  }
}

export function touchNodeVisibility (node) {
  return touchNode(node, 'display__updated_at')
}

export function touchNodeWeighting (node) {
  return touchNode(node, 'discover__updated_at')
}



// WEBPACK FOOTER //
// ./src/redux/keywords.js